import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoCheck24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M6.7915 13.0417L9.91651 16.1667L17.2082 7.83337" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoCheck24;